import { render, staticRenderFns } from "./feature-item.vue?vue&type=template&id=70e535f9&scoped=true"
import script from "./feature-item.vue?vue&type=script&lang=js"
export * from "./feature-item.vue?vue&type=script&lang=js"
import style0 from "./feature-item.vue?vue&type=style&index=0&id=70e535f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e535f9",
  null
  
)

export default component.exports